import c from './Landing.module.css';
import { PLATFORM } from './data';

export function Platform() {
  return (
    <section id="platform" className={`${c.container} ${c.section}`}>
      <div className={c.sectionHead}>
        <div>
          <div className={c.eyebrow}>02 — WHAT WE DO FOR CLIENTS</div>
          <h2 className={c.h2}>Six practice areas, one team</h2>
        </div>
        <p className={c.sectionBlurb}>
          From custom agent runtimes to production-grade retrieval — the practice areas we bring to enterprise engagements.
        </p>
      </div>
      <div className={c.capList}>
        {PLATFORM.map((cap) => (
          <div key={cap.num} className={c.capRow}>
            <div className={c.capNum}>{cap.num}</div>
            <div>
              <div className={c.capTitle}>{cap.title}</div>
              <div className={c.capTag}>{cap.tag}</div>
            </div>
            <div className={c.capItems}>
              {cap.items.map((it) => <span key={it} className={c.chip}>{it}</span>)}
            </div>
          </div>
        ))}
        <div className={c.capEnd} />
      </div>
    </section>
  );
}
